import { IonLabel, IonSegment, IonSegmentButton } from '@ionic/react';
import { useField } from 'formik';
import { HTMLAttributes, useCallback } from 'react';
import './ion-form-text-switch.css';

interface TextToggleButton {
  value: string;
  label: string;
  onClick?: (name: string) => void;
}

interface TextToggleInputProps {
  name: string;
  leftButton: TextToggleButton;
  rightButton: TextToggleButton;
  containerProps?: HTMLAttributes<HTMLDivElement>;
}

const IonFormTextSwitchField = (props: TextToggleInputProps) => {
  const { leftButton, rightButton, name, containerProps } = props;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [field, _meta, helper] = useField(name);

  const handleButtonClickCb = useCallback(
    (buttonProps: TextToggleButton) => {
      return () => {
        if (typeof buttonProps.onClick === 'function') {
          buttonProps.onClick(buttonProps.value);
        }
        helper.setValue(buttonProps.value);
      };
    },
    [helper]
  );

  const { className, ...restDivProps } = containerProps ?? {};

  const classList = ['text-switch-field'];
  if (className) {
    classList.push(...className.split(' '));
  }

  return (
    <div className={classList.join(' ')} {...restDivProps}>
      <IonSegment value={field.value} color="primary">
        <IonSegmentButton
          value={leftButton.value}
          onClick={handleButtonClickCb(leftButton)}
        >
          <IonLabel>{leftButton.label}</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton
          value={rightButton.value}
          onClick={handleButtonClickCb(rightButton)}
        >
          <IonLabel>{rightButton.label}</IonLabel>
        </IonSegmentButton>
      </IonSegment>
    </div>
  );
};

export { IonFormTextSwitchField };
